import React, { useEffect, useRef } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Formik, Form, Field, FieldArray, getIn, ErrorMessage } from 'formik';
import { setFillPassportModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import { IProps, IFormValue, InsuredState } from 'components/FillPassportModal/types';
import Modal from 'components/Modal';
import * as Yup from 'yup';
import _ from 'lodash';
import InputWithRegex from 'components/InputWithRegex';
import { NumberOnlyRegex } from 'utils/commonValidations';
import { InsuredListContent, ListDataContent, PolicyAddEnListReq } from 'bff/models/product';
// import service from 'bff/services/travelProductService';
import { InsuredRelation } from 'constants/enums/insuredRelation.enum';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';

const initInsuredState: InsuredState = {
  INSURED_RELATION: '',
  INSURED_ID: '',
  INSURED_NAME: '',
  INSURED_PASSPORT_NO: '',
  INSURED_PASSPORT_NAME: ''
};

const initialValues: IFormValue = {
  INSUREDS: [
    { ...initInsuredState }
  ]
};

const validationSchema = Yup.object().shape({
  INSUREDS: Yup.array().of(
    Yup.object().shape({
      INSURED_PASSPORT_NO: Yup.string().required('此為必填欄位').length(9, '護照號碼長度為 9 字元').matches(/\d/, '限輸入數字'),
      INSURED_PASSPORT_NAME: Yup.string().required('此為必填欄位').max(50, '護照姓名最大長度為 50 字元').matches(/^[A-Za-z-, ]*$/, '限輸入英文、空格、「,」、「 –」')
    })
  )
});

const FillPassportModal: React.FC<IProps> = (props) => {
  /** 表單參考 */
  const formikRef: any = useRef();
  const handleClose = () => {
    props.setFillPassportModalVisible(false);
  };

  useEffect(() => {
    if (props.modal.fillPassportModalState.insureds && formikRef && formikRef.current) {
      const insureds: InsuredState[] = new Array(0);

      _.forEach(props.modal.fillPassportModalState.insureds, (insured: any) => {
        insureds.push({
          INSURED_RELATION: insured.INSURED_RELATION || insured.LTYPE,
          INSURED_ID: insured.INSURED_ID || insured.ID,
          INSURED_NAME: insured.INSURED_NAME || insured.NAME,
          INSURED_PASSPORT_NAME: '',
          INSURED_PASSPORT_NO: ''
        });
      });

      formikRef.current.setFieldValue('INSUREDS', [...insureds]);
    }
  }, [props.modal.fillPassportModalState.insureds]);

  const handleSubmit = async (values: IFormValue) => {
    const insuredEn: InsuredListContent = {
      APPLY_NO: props.modal.fillPassportModalState.serialNo || '',
      POLICY_NO: '',
      DATA: _.map(values.INSUREDS, (insured: any) => {
        const dataContent: ListDataContent = {
          LTYPE: insured.INSURED_RELATION === InsuredRelation.Self ? RuleCheckInsuredType.Applicant : RuleCheckInsuredType.Insured,
          ID: insured.INSURED_ID,
          NAME_TC: insured.INSURED_NAME,
          NAME_PASSPORT: insured.INSURED_PASSPORT_NAME,
          PASSPORT_SN: insured.INSURED_PASSPORT_NO
        };

        return dataContent;
      })
    };

    const addEnListReq: PolicyAddEnListReq = {
      INSUREDLIST: [insuredEn]
    };

    // console.log('enlist values', values);
    // console.log('enlist serialNo', props.modal.fillPassportModalState.serialNo);
    // console.log('enlist addEnListReq', addEnListReq);
    // const res = await service.addPolicyEnList(addEnListReq);
    // if (res) {
    //   handleClose();
    // }

    if (props.modal.fillPassportModalState.setAddEnListReq) props.modal.fillPassportModalState.setAddEnListReq(addEnListReq);
    handleClose();
  };

  const handleCancel = () => {
    if (props.modal.fillPassportModalState.setAddEnListReq) props.modal.fillPassportModalState.setAddEnListReq(null);
    handleClose();
  };

  return (
    <>
      {props.modal.fillPassportModalState.visible && (
        <div className="fill-passport-modal">
          <Modal
            visible={props.modal.fillPassportModalState.visible}
            title="如需申請英文投保證明，請填寫被保險人護照資料"
            confirmButton={false}
            cancelButton={false}
            onCancel={handleClose}
          >
            <Formik
              innerRef={formikRef}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {
                ({ values, errors, touched, setFieldTouched }) => (
                  <Form>
                    <div className="fill-passport-modal__content">
                      <FieldArray name="INSUREDS">
                        {
                          () => (
                            <>
                              {
                                values.INSUREDS ? (
                                  _.map(values.INSUREDS, (insured: any, index: number) => {
                                    return (
                                      <div className="fill-passport-modal__row" key={index}>
                                        <div className="element__form-group">
                                          <div className="element__form-group-title">被保險人姓名</div>
                                          <Field type="text" name={`INSUREDS[${index}].INSURED_NAME`} className="element__input" disabled />
                                          <div className="element__error-message">
                                            <ErrorMessage name={`INSUREDS[${index}].INSURED_NAME`} className="element__error-message" />
                                          </div>
                                        </div>
                                        <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_PASSPORT_NO`) && getIn(touched, `INSUREDS[${index}].INSURED_PASSPORT_NO`) ? ' element__form-group--invalid' : '')}>
                                          <div className="element__form-group-title">護照號碼</div>
                                          <Field
                                            component={InputWithRegex}
                                            regex={NumberOnlyRegex}
                                            maxLength={9}
                                            name={`INSUREDS[${index}].INSURED_PASSPORT_NO`}
                                            className="element__input"
                                            autoComplete="off"
                                            placeholder="請填寫護照號碼"
                                            onBlur={() => {
                                              setFieldTouched(`INSUREDS[${index}].INSURED_PASSPORT_NO`, true);
                                            }}
                                          />
                                          <div className="element__error-message">
                                            <ErrorMessage name={`INSUREDS[${index}].INSURED_PASSPORT_NO`} className="element__error-message" />
                                          </div>
                                        </div>
                                        <div className={'element__form-group' + (getIn(errors, `INSUREDS[${index}].INSURED_PASSPORT_NAME`) && getIn(touched, `INSUREDS[${index}].INSURED_PASSPORT_NAME`) ? ' element__form-group--invalid' : '')}>
                                          <div className="element__form-group-title">護照英文姓名</div>
                                          <Field type="text" maxLength={200} name={`INSUREDS[${index}].INSURED_PASSPORT_NAME`} className="element__input" autoComplete="off" placeholder="請填寫護照名字" />
                                          <div className="element__error-message">
                                            <ErrorMessage name={`INSUREDS[${index}].INSURED_PASSPORT_NAME`} className="element__error-message" />
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : null
                              }
                            </>
                          )
                        }
                      </FieldArray>
                    </div>
                    <div className="fill-passport-modal__info">
                      <p>投保成功後，英文投保證明將併同電子保單同時寄送。</p>
                    </div>
                    <div className="fill-passport-modal__controls">
                      <button type="submit" className="element__button element__button--red">申請及送出</button>
                      <button type="button" className="element__button element__button--red" onClick={handleCancel}>無需申請</button>
                    </div>
                  </Form>
                )
              }
            </Formik>
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setFillPassportModalVisible: (visible: boolean) => dispatch(setFillPassportModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(FillPassportModal);
